import { useNavigate, useLocation } from 'react-router-dom';
import ShimmerButton from '../components/magicui/shimmer-button';
import { motion } from 'framer-motion';

const Success = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Récupérer les paramètres de l'URL
  const queryParams = new URLSearchParams(location.search);
  const purchaseType = queryParams.get('purchaseType');

  // Déterminer le contenu de la modale en fonction du type d'achat
  const getModalContent = () => {
    if (purchaseType === 'bilan') {
      return (
        <>
          <h2
            className="text-3xl mb-6"
            style={{ color: '#003942', fontFamily: "'Cormorant', serif", fontWeight: 700 }}
          >
            Merci pour votre confiance !
          </h2>
          <p className="mb-4 text-gray-600" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Vous allez immédiatement recevoir un mail<br />
            avec votre budget prévisionnel à 3 ans.
          </p>
          <div className="flex justify-center mt-8">
            <ShimmerButton
              background="#003942"
              shimmerColor="#45B8A9"
              onClick={() => navigate('/')}
            >
              <span style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600 }}>
                Retour à l'accueil
              </span>
            </ShimmerButton>
          </div>
        </>
      );
    }
    // Contenu par défaut si `purchaseType` n'est pas défini
    return (
      <>
        <h2
          className="text-3xl mb-6"
          style={{ color: '#003942', fontFamily: "'Cormorant', serif", fontWeight: 700 }}
        >
          Merci pour votre confiance !
        </h2>
        <p className="mb-4 text-gray-600" style={{ fontFamily: "'Outfit', sans-serif" }}>
          Vous allez immédiatement recevoir un mail.
        </p>
        <div className="flex justify-center mt-8">
          <ShimmerButton
            background="#003942"
            shimmerColor="#45B8A9"
            onClick={() => navigate('/')}
          >
            <span style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600 }}>
              Retour à l'accueil
            </span>
          </ShimmerButton>
        </div>
      </>
    );
  };

  return (
    <div className="flex items-center justify-center min-h-screen" style={{ background: 'linear-gradient(180deg, #f8fffe 0%, #eef7f5 40%, #f0f9f7 100%)' }}>
      <motion.div
        className="bg-white p-10 md:p-14 rounded-2xl shadow-sm border border-gray-100 text-center max-w-lg mx-4"
        initial={{ opacity: 0, y: 30, scale: 0.97 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.6 }}
      >
        <div className="w-16 h-16 rounded-full mx-auto mb-8 flex items-center justify-center" style={{ backgroundColor: 'rgba(69,184,169,0.1)' }}>
          <svg width={32} height={32} viewBox="0 0 24 24" fill="none" stroke="#45B8A9" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 6 9 17l-5-5" />
          </svg>
        </div>
        {getModalContent()}
      </motion.div>
    </div>
  );
};

export default Success;
